export const whiteLabelsApi = {
  'shab.safarmarket.co': 'https://api-shab.safarmarket.co/api/fa/sandbox/v_1_4',
} as const
